import { useState } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { FaPlus } from "react-icons/fa6";
import { Trans, useTranslation } from "react-i18next";
import { updateUser } from "@slices/userSlice";
import Product from "@ltypes/product";
import User from "@ltypes/user";
import Button from "@components/forms/Button/Button";
import Lumeba from "@components/ui/Lumeba/Lumeba";
import AddLumebaModal from "@components/modals/AddLumebaModal/AddLumebaModal";
import "./LumebasPage.scss";

function LumebasPage() {
    const [isAddLumebaModalVisible, setAddLumebaModalVisible] = useState<boolean>(false);

    const user: User|null = useSelector((state: any) => state.user);
    const dispatch = useDispatch();

    const { t } = useTranslation();

    const handleNewProduct = (newProduct: Product) => {
        if(!user)
            return;
        dispatch(updateUser({products: [newProduct, ...user.products]}));
    };

    return (
        <>
            <div className="p-3">
                <h1>{t('title.home')}</h1>

                <div className="text-center">
                    <Button onClick={() => setAddLumebaModalVisible(!isAddLumebaModalVisible)}>
                        <FaPlus size="1rem"/>
                        {t('page.home.input.add_new_lumeba')}
                    </Button>
                </div>

                <div className="mt-3">
                    <div className="row g-3">
                        {user && user.products.map((product: Product, index: number) => (
                            <div key={index} className="col-12 col-sm-6 col-md-4 col-lg-4">
                                <Lumeba lumeba={product}/>
                            </div>
                        ))}
                        {user && user.products.length === 0 && (
                            <div className="home-description">
                                <Trans i18nKey="page.home.description" components={{ lnk: <Link to="https://lumeba.com" target="_blank"/> }} />
                            </div>
                        )}
                    </div>
                </div>

                <div className="mt-3 text-center">
                    <span className="home-contact-message" dangerouslySetInnerHTML={{ __html: t('page.home.contact') }}/>
                </div>
            </div>
            <AddLumebaModal visible={isAddLumebaModalVisible} onHide={() => setAddLumebaModalVisible(false)} onPair={handleNewProduct}/>
        </>
    );
}

export default LumebasPage;
